module.exports = __webpack_public_path__ + "static/media/Alert.b1fb57fd.svg";